import CookieConsent from "react-cookie-consent";
import { useEffect } from "react";
import { CONSENT_COOKIE_NAME, getConsentStatus, triggerGtmConsent } from "../../utils/cookieManager.ts";

const CookieConsentBanner: React.FC = () => {
    useEffect(() => {
        if (getConsentStatus() === "granted") {
            triggerGtmConsent("granted");
        }
    }, []);

    return (
        <CookieConsent
            location="none"
            buttonText="Alle akzeptieren"
            declineButtonText="Ablehnen"
            enableDeclineButton
            onAccept={() => triggerGtmConsent("granted")}
            onDecline={() => triggerGtmConsent("denied")}
            cookieName={CONSENT_COOKIE_NAME}
            overlay
            overlayStyle={{
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 9998,
            }}
            style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                maxWidth: "480px",
                width: "90%",
                background: "#fff",
                color: "#333",
                borderRadius: "12px",
                padding: "32px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                zIndex: 9999,
                display: "flex",
                flexDirection: "column",
                gap: "16px",
            }}
            contentStyle={{
                fontSize: "14px",
                lineHeight: "1.6",
                margin: 0,
            }}
            buttonWrapperClasses="cookie-btn-wrapper"
            buttonStyle={{
                background: "rgb(243, 156, 97)",
                color: "#00031f",
                fontWeight: 600,
                fontSize: "14px",
                borderRadius: "24px",
                padding: "10px 24px",
                border: "none",
                cursor: "pointer",
            }}
            declineButtonStyle={{
                background: "transparent",
                color: "#666",
                fontWeight: 500,
                fontSize: "14px",
                borderRadius: "24px",
                padding: "10px 24px",
                border: "1px solid #ccc",
                cursor: "pointer",
            }}
        >
            <h3 style={{ fontSize: "18px", display: "block", marginBottom: "8px" }}>
                🍪 Cookie-Einstellungen
            </h3>
            <span style={{ display: "inline-block", paddingTop: "1rem" }}>
                Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten.
                Einige Cookies sind notwendig, während andere uns helfen, die Website und Ihren Besuch zu analysieren.
            </span>
        </CookieConsent>
    );
};

export default CookieConsentBanner;
